import { render, staticRenderFns } from "./property-inventory.vue?vue&type=template&id=c8fb9fb2&"
import script from "./property-inventory.vue?vue&type=script&lang=js&"
export * from "./property-inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports